// import React from "react"
// import "./blog.css"

// const Marketing = () =>{
//     return "Marketing";
// }

// export default Marketing  

import React from "react"
import "./blog.css"
import blogInfo from "./blog-info"
import { Col, Row } from "react-bootstrap"

const RandomNumberSet = (n) =>{
    var arr = [];
    while(arr.length < n){
        var r = Math.floor(Math.random() * 5) + 1;
        if(arr.indexOf(r) === -1) arr.push(r);
    }
    return arr
}

const Marketing = () =>{
    return (
        <Col sm={12} className="allpost-main">
            <Col sm={12} className="allpost-main-header">
                <div className="allpost-main-header-container">
                    <h3>The Latest</h3>
                    {
                    [Math.floor(Math.random() * 3)+1].map((val, idx)=>(
                        
                        <div key={idx} className="allpost-main-header-img-info">
                            {/* {console.log(val)} */}
                            <div className="allpost-main-header-img">
                                <img src={blogInfo["Marketing"][val]["image"]} alt="top trending Marketing" />
                            </div>
                            <div className="allpost-main-header-info">
                                <div className="allpost-main-header-info-main">
                                    <p className="outlier"> Marketing Tip: {blogInfo["Marketing"][val]["readingTime"]} minute read </p>
                                    <h4>
                                        {blogInfo["Marketing"][val]["title"]}
                                    </h4>
                                    <p className="outlier">
                                        {blogInfo["Marketing"][val]["discriptions"]}
                                    </p>
                                    <div className="postAuthor">
                                        <div className="authoreImage">
                                            <img className="authore-img" src={blogInfo["Marketing"][val]["authoreImage"]}  alt={blogInfo[Object.keys(blogInfo)[val]][val]["authore"]} />
                                        </div>
                                        <div className="authoreName">
                                            <p className="outlier1">written by</p>
                                            <p>
                                                <b>
                                                    {blogInfo["Marketing"][val]["authore"]}
                                                </b>
                                            </p>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>

                    ))
                    }
                </div>
            </Col>
            <Col sm={12} className="allpost-main-body">
                {
                // blogInfo["Design_And_Trends"].map((val, idx)=>(

                    <div className="allpost-main-body-information">
                        <h4 style={{margin: "20px 0 20px 0"}}>{"Marketing".replace("_", " ").replace("_", " ")}</h4>
                        <Row className="allpost-main-body-blogs">

                            {
                            
                                blogInfo["Marketing"].map((val, idx)=>(

                                    <Col sm={4} key={idx}className="allpost-main-body-blogs-article">
                                        <div className="allpost-main-body-blogs-header">
                                            <img src={val["image"]} alt="" />
                                            <p className="outlier2">
                                                Marketing Tip: {val["readingTime"]} minute read
                                            </p>
                                            <h6 className="outlier3">
                                                {val["title"]}
                                            </h6>
                                        </div>
                                        <div className="allpost-main-body-blogs-content">
                                            <p>
                                                {val["discriptions"]}
                                            </p>
                                        </div>
                                        <div className="allpost-main-body-blogs-authore">
                                            <div className="postAuthor1">
                                                <div className="authoreImage">
                                                    <img className="authore-img" src={val["authoreImage"]}  alt={val["authore"]} />
                                                </div>
                                                <div className="authoreName">
                                                    <p className="outlier1">written by</p>
                                                    <p>
                                                        <b>
                                                            {val["authore"]}
                                                        </b>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                ))
                                
                            }

                            
                        </Row>
                    </div>

                // ))
                }
            </Col>
        </Col>
    );
}

export default Marketing